import * as React from 'react';
import Translate from 'react-translate-component';
import { cx } from './util';
import styles from "./main.module.scss";
import { translateService } from '../../services/TranslateService';
import {IVehicleSearch} from '../../interfaces/VehicleSearch';
import {useEffect, useState} from 'react';
import{CustomerCheckboxInput, CustomerTextInput,
  CountrySelect} from '../CustomerInput/CustomerInput';
import {
  useValidCompanyName, useValidCompanyId, useValidGivenName, useValidFamilyName,
  useValidCompanyRef, useIsCompany, useIsCountryForeign, useValidPhoneNumber,
  useValidEmail, useValidForeignCountryName, useValidZipCode,
  useValidCity, useValidAddress, useValidSocialSecurityNum, useValidDateOfBirth,
  checkBirthdateFromLogin, useValidAddDriverNumber
} from '../../hooks/useCustomerHooks';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {useDispatch, useSelector} from "react-redux";
import {GlobalStore} from "../../reduxStore";
import { DataContext } from '../../contexts/dataContext';

interface PropsInterface {
  vehicle?: IVehicleSearch;
  back: Function;
  next: Function;
  setShowLogin: any;
}

export default function CustomerInfoNew({ setShowLogin, vehicle, back, next }: PropsInterface) {
  const { version } = require("../../../package.json");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const {user, customer, services, changeCustomer, changeUser, sendGaEvent, noUnderTwentyOne } = React.useContext(DataContext)
  const [isCustomerLoggedIn, setIsCustomerLoggedIn] = React.useState<boolean>(!!(customer?.loggedIn && checkBirthdateFromLogin(user?.birthDate)));
  const {isCompany, setIsCompany, isCompanyErrorString} = useIsCompany(!!user?.company?.name?.length);
  const {isCountryForeign, setIsCountryForeign, isCountryForeignErrorString } = useIsCountryForeign(!!user?.country);
  const {companyName, setCompanyName, companyNameErrorString, setCompanyNameErrorOverride, handleCompanyNameFieldErr,
    companyNameFieldRef} = useValidCompanyName(user?.company?.name || '', "companyNameField");
  const {companyId, setCompanyId, companyIdErrorString, setCompanyIdErrorOverride, handleCompanyIdFieldErr,
    companyIdFieldRef} = useValidCompanyId(user?.company?.vatNumber || '', "companyIdField");
  const {companyRef, setCompanyRef, companyRefErrorString, setCompanyRefErrorOverride} = useValidCompanyRef(user?.company?.reference || '');
  const {givenName, setGivenName, givenNameErrorString, handleGivenNameFieldErr, givenNameFieldRef} =
      useValidGivenName(user?.givenName || '', "givenNameField");
  const {familyName, setFamilyName, familyNameErrorString, handleFamilyNameFieldErr,familyNameFieldRef} =
      useValidFamilyName(user?.familyName || '', "familyNameField");
  const {phoneNumber, reEnterPhone, setPhoneNumber, phoneNumberErrorString, setReEnterPhone, reEnterPhoneErrorString,
    handlePhoneNumFieldErr, phoneNum1FieldRef, phoneNum2FieldRef } = useValidPhoneNumber(user?.phoneNumber || '',
      "phoneNumField1","phoneNumField2", !user?.id ? (customer?.phoneNumber2 || '') : user?.phoneNumber || '');
  const {email, reEnterEmail, setEmail, emailErrorString, reEnterEmailErrorString, setReEnterEmail, handleEmailFieldErr,
    email1FieldRef, email2FieldRef } = useValidEmail(user?.email || "", "emailField1", "emailField2", customer?.email2 || '');
  const {dateOfBirth, setDateOfBirth, dateOfBirthErrorString, setDateOfBirthErrorOverride, handleDateOfBirthFieldErr,
    dateOfBirthFieldRef } = useValidDateOfBirth(user?.birthDate || user?.birthday || '', "dateOfBirthField",
      noUnderTwentyOne);
  const {socialSecurityNum, setSocialSecurityNum, socialSecurityNumErrorString, setSocialSecurityNumErrorOverride,
    handleSSNFieldErr, SSNFieldRef } = useValidSocialSecurityNum(customer?.personalIdCode || '',
      isCustomerLoggedIn, "socialSecurityField", noUnderTwentyOne,
      (!isCountryForeign && !user?.birthDate), user?.birthDate);
  const {foreignCountry, setForeignCountry, foreignCountryErrorString, setForeignCountryErrorOverride,
    handleCountryFieldErr, countryFieldRef} = useValidForeignCountryName(user?.country ?? '', "countryField");
  const {address, setAddress, addressErrorString, handleAddressFieldErr, addressFieldRef} = useValidAddress(user?.address || '', "addressField");
  const {city, setCity, cityErrorString, handleCityFieldErr, cityFieldRef} = useValidCity(user?.municipality || '', "cityField");
  const {zipCode, setZipCode, zipCodeErrorString, handleZipCodeFieldErr, zipCodeFieldRef} = useValidZipCode(user?.postalCode || '', "zipCodeField",
      (foreignCountry?.toUpperCase() !== 'FINLAND' && isCountryForeign) || customer?.registeredForeigner);
  const {handleAddDriverNumFieldErr} = useValidAddDriverNumber(services.addDriverNumber ||'',
      'addDriverNumberField', customer?.phoneNumber || '', !(services.additionalDriver));
  const [privateNum, setPrivateNum] = useState(false); // note: private + prepaid can both be selected (this is an and/or case)
  const [prepaidNum, setPrepaidNum] = useState(false);
  const dispatch = useDispatch();
  const apiService = useSelector((service: GlobalStore) => service.chauffeurReducer.apiService);
  const language = useSelector((deviceLang: GlobalStore) => deviceLang.chauffeurReducer.deviceLanguage);
  const [ submitValidationErrorString, setSubmitValidationErrorString ] = useState('');
  const [ saveInfoBtnClicked, setSaveInfoBtnClicked ] = useState(false);
  const [ firstRenderComplete, setFirstRenderComplete ] = useState<boolean>(false);

  useEffect(() => {
    setCompanyNameErrorOverride(!isCompany);
    setCompanyIdErrorOverride(!isCompany);
    setCompanyRefErrorOverride(!isCompany);

    if(!isCompany) { // clear out existing strings if company option is disabled, allows for customer update on BE
      if(companyName.length) {setCompanyName('')};
      if(companyId.length) {setCompanyId('')};
      if (companyRef.length) {setCompanyRef('')};
    }

  }, [isCompany]);

  useEffect(() => {
    setDateOfBirthErrorOverride(!isCountryForeign || (user?.id && checkBirthdateFromLogin(user?.birthDate)) ? true : false); // BIRTHDATE
    setSocialSecurityNumErrorOverride(isCountryForeign); // SSN
    setForeignCountryErrorOverride(!isCountryForeign); // COUNTRY NAME NEEDED

    // if switch to foreign - SSN must be empty and vice versa, else there will be a data conflict
    if (isCountryForeign) {
      if(socialSecurityNum) {setSocialSecurityNum('')}
    } else {
      if(foreignCountry) {setForeignCountry('')}
      if(dateOfBirth) {setDateOfBirth('')}
    }
  }, [isCountryForeign]);

  useEffect(() => {
    if (customer === undefined) {
      customerValuesUpdate();
      return;
    }

    if (customer) { // sets field data when existing customer logs in
      if (customer.companyName || customer.companyVatNumber || customer.companyReference) {
        setIsCompany(true);
        if (customer.companyName) {setCompanyName(customer.companyName)}
        if (customer.companyVatNumber) {setCompanyId(customer.companyVatNumber)}
        if (customer.companyReference) {setCompanyRef(customer.companyReference)}}
      else {
        if (isCompany) {setIsCompany(false)} } // resets company checkbox if checked before login
      if (customer.givenName) {setGivenName(customer.givenName)}
      if (customer.familyName) {setFamilyName(customer.familyName)}
      if (customer.phoneNumber) {setPhoneNumber(customer.phoneNumber)}
      if (customer.email) {setEmail(customer.email)}
      if (customer.loggedIn) {
        if(!isCustomerLoggedIn) {setIsCustomerLoggedIn(true)}
        setReEnterEmail(customer.email);
        setReEnterPhone(customer.phoneNumber);
        setDateOfBirthErrorOverride(true)
      } else if (user?.id) { // if birthdate incorrect case, phone number still cannot be edited
        setReEnterPhone(customer.phoneNumber);
      }
      if ((customer.registeredForeigner || customer.unregisteredForeigner) ) {
        setIsCountryForeign(true);
        if (customer.dateOfBirth) {setDateOfBirth(customer.dateOfBirth)}
        if (customer.country) { setForeignCountry(customer.country) }
      } else {
        if (customer.personalIdCode) {setSocialSecurityNum(customer.personalIdCode)}
        if (isCountryForeign && customer.personalIdCode) {setIsCountryForeign(false)} // resets foreign country checkbox if checked before login
      }
      if (customer.address) {setAddress(customer.address)}
      if (customer.municipality) {setCity(customer.municipality)}
      if (customer.postalCode) {setZipCode(customer.postalCode)}
      if (customer.prepaid) {setPrepaidNum(customer.prepaid)}
      if (customer.secret) {setPrepaidNum(customer.secret)}
    }

  }, [customer]);

  const UpdateUser = (triggerSaveToCustomer: boolean) => {
    changeUser({
      ...user,
      givenName: givenName,
      familyName: familyName,
      address: address,
      postalCode: zipCode,
      email: email,
      country: foreignCountry,
      birthday: dateOfBirth,
      phoneNumber: phoneNumber,
      personal_id_code: socialSecurityNum,
      municipality: city,
      company: {name: companyName, vatNumber: companyId, reference: companyRef},
      saveToCustomer: triggerSaveToCustomer, // to update customer object only when necessary
    });
  };

  const customerValuesUpdate = () => {
    changeCustomer({
      address: address,
      company: isCompany,
      companyName: companyName,
      companyReference: companyRef,
      companyVatNumber: companyId,
      country: foreignCountry,
      dateOfBirth: isCustomerLoggedIn ? (customer?.dateOfBirth ?? user?.birthDate ?? user?.birthday) : dateOfBirth,
      // 2 user birth-dates --> '.birthdate' from /customers/me && '.birthday' from value physically typed by user (this helps differentiate)
      // above ternary: bugfix for dateOfBirth setting to '' directly after customer logins --> birthdate cannot be changed if logged in
      email: email,
      email2: email,
      emailConsent: "false",
      fairAccept: false,
      familyName: familyName,
      givenName: givenName,
      loggedIn: isCustomerLoggedIn,
      mayUseQuota: user?.mayUseQuota ?? false, // can set quota from user data if it exists, it shall not affect customer info components
      municipality: city,
      noBirthday: true,
      personalIdCode: socialSecurityNum,
      phoneNumber: phoneNumber,
      phoneNumber2: '',
      postalCode: zipCode,
      prepaid: prepaidNum,
      registeredForeigner: (isCustomerLoggedIn && isCountryForeign),
      secret: privateNum,
      unregisteredForeigner: (!isCustomerLoggedIn && isCountryForeign),
      relativeBankTransferDueDate: user?.relativeBankTransferDueDate,
      mayUseBankTransferAnytime: user?.mayUseBankTransferAnytime ?? false,
    })


  };

  useEffect(() => {
    // update submit button error string when all fields are completed without clicking submit
    let fieldErrorStrings = companyNameErrorString.length || companyIdErrorString.length || companyRefErrorString.length || givenNameErrorString.length ||
        familyNameErrorString.length || phoneNumberErrorString.length || reEnterPhoneErrorString.length || phoneNumberErrorString.length || reEnterPhoneErrorString.length ||
        reEnterPhoneErrorString.length || emailErrorString.length || reEnterEmailErrorString.length || dateOfBirthErrorString.length ||
        foreignCountryErrorString.length || addressErrorString.length || cityErrorString.length || zipCodeErrorString.length;

    if (fieldErrorStrings === 0 && submitValidationErrorString.length > 0) {
      setSubmitValidationErrorString('');
    }
  }, [companyNameErrorString, companyIdErrorString, companyRefErrorString, givenNameErrorString,
    familyNameErrorString, phoneNumberErrorString, reEnterPhoneErrorString, phoneNumberErrorString,
    reEnterPhoneErrorString, reEnterPhoneErrorString, emailErrorString, reEnterEmailErrorString,
    dateOfBirthErrorString, foreignCountryErrorString, addressErrorString, cityErrorString,
    zipCodeErrorString, submitValidationErrorString])
  
  useEffect(() => {
    if(!firstRenderComplete) {
      UpdateUser(true);
      setFirstRenderComplete(true);
    } else { UpdateUser(false) }

    customerValuesUpdate();

  }, [givenName, familyName, socialSecurityNum, address, zipCode, email, foreignCountry,
    dateOfBirth, phoneNumber, companyName, companyRef, companyId, city, submitValidationErrorString]);

  const handleSubmit = (e: any) => {
    setFormSubmitted(true);
    const checkValidationFields = () => {
      // uses the hook functions to check errors and return component names for autoscroll if err exists
      if(handleCompanyNameFieldErr()) { return handleCompanyNameFieldErr() }
      if(handleCompanyIdFieldErr()){ return handleCompanyIdFieldErr() }
      if(handleGivenNameFieldErr()) { return handleGivenNameFieldErr() }
      if(handleFamilyNameFieldErr()) { return handleFamilyNameFieldErr() }
      if(handleDateOfBirthFieldErr()) { return handleDateOfBirthFieldErr() }
      if(handleSSNFieldErr()) { return handleSSNFieldErr() }
      if(handleAddressFieldErr()) { return handleAddressFieldErr() }
      if(handleCityFieldErr()) { return handleCityFieldErr() }
      if(handleZipCodeFieldErr()) { return handleZipCodeFieldErr() }
      if(handleCountryFieldErr()) { return handleCountryFieldErr() }
      if(handlePhoneNumFieldErr()) { return handlePhoneNumFieldErr() }
      if(handleEmailFieldErr()) { return handleEmailFieldErr() }
      if(handleAddDriverNumFieldErr()) {return "addDriverNumErr"}
      customerValuesUpdate();  // if no error, update and return
      return null
    }
    let fieldError = checkValidationFields();
    let errorFields = checkValidationFields();
    if (errorFields !== null) {
      setSubmitValidationErrorString(translateService.translate("vehicleSearch1.invalidSaveInfo"));
    } else { setSubmitValidationErrorString('') }
    UpdateUser(true);
    if (fieldError) {
      console.log("Some fields have not been completed correctly, first err field: ");
      console.log(fieldError);
      if(fieldError === "addDriverNumErr") {
        setSubmitValidationErrorString(translateService.translate("vehicleSearch1.additionalDriverNumberSameAsMain"));
      } else {
        setSubmitValidationErrorString(translateService.translate("vehicleSearch1.invalidSaveInfo"));
      }

      // uses component name to auto scroll to error field
      let inputField = document.querySelector('[name="' + fieldError + '"]');
      inputField?.scrollIntoView({behavior: "smooth", block: "center"})
    } else {
      setSubmitValidationErrorString('');
      handleSaveUser(); // only performs save when validation is completed
    }
  }

  const handleSaveUser = async () => {
    if (apiService && user) {
      let customerValues;
      let values: any = customer;

      let {registeredForeigner, noBirthday, mayUseQuota, phoneNumber2, mayUseBankTransferAnytime,
        loggedIn, dateOfBirth, personalIdCode, email2, unregisteredForeigner,
        fairAccept, ...customerValuesInitial } = values;

      if (unregisteredForeigner || registeredForeigner) { // Foreign customers
        customerValues = {
          ...customerValuesInitial,
          birthDate: dateOfBirth !== '' ? dateOfBirth : (user?.birthDate ?? user?.birthday ?? ''), // birth date value should never be empty hence fallback cases
          noPersonalIdCode: user?.smsLogin && user?.noPersonalIdCode !== undefined ? user?.noPersonalIdCode : true,
          emailConsent: false, // BE requires this for now - after fine tune --> remove
          personalIdCode: dateOfBirth !== '' ? dateOfBirth : (user?.birthDate ?? user?.birthday ?? ''),
          login: isCustomerLoggedIn,
          // remove white spaces from email and phone number:
          email: email.trim(),
          phoneNumber: phoneNumber.replace(/\s/g,''),
          rrmVersion: version
        }} else { // Finnish customers
        customerValues = {
          ...customerValuesInitial,
          birthDate: dateOfBirth !== '' ? dateOfBirth : (user?.birthDate ?? user?.birthday ?? ''),
          noPersonalIdCode: user?.smsLogin && user?.noPersonalIdCode !== undefined ? user?.noPersonalIdCode : false,
          emailConsent: false, // BE requires this for now - after fine tune --> remove
          personalIdCode: personalIdCode,
          login: isCustomerLoggedIn,
          email: email.trim(),
          phoneNumber: phoneNumber.replace(/\s/g,''),
          rrmVersion: version
        }
      }

      const userInfo = {...customerValues, language: user?.language ?? language};
      dispatch({
        type: 'SET_API_MESSAGE',
        payload: translateService.translate('vehicleSearch1.creatingCustomer'),
      });
        await apiService.user.saveUserDetails(userInfo).then((res) => {
          dispatch({type: 'SET_API_MESSAGE', payload: null});
          if (res.id) {
            next(values);
            changeUser({...user, id: res.id});
          }

          if ((window as any).ap3c){
            // add customer when we know the email and if ap3c func exists
            console.log('Ortto Tracking on');
            (window as any).ap3c.track({"v":0 ,"email": customer?.email ?? user?.email});
          } else {
            console.log('Ortto Tracking off');
          }

          console.log(res);
        }).catch ((e) => {
          if(e.includes("INVALID_BODY_ERROR")) {
            let errorString = e;
            dispatch({
              type: "SET_RESPONSE_MODAL",
              payload: translateService.translate('profileCompletenessPhase.messages.savingFailed') +
                  " (Reason for error:  " + errorString.slice(28, errorString.indexOf("}\"")) + ")"
            });
          } else {
            dispatch({
              type: "SET_RESPONSE_MODAL",
              payload: translateService.translate('profileCompletenessPhase.messages.savingFailed') + " (Reason for error:  " + e + ")",
            });
          }
          dispatch({type: 'SET_API_MESSAGE', payload: null});
          sendGaEvent('createCustomer', 'createCustomerFail', '', 0);
        });
    }
  }
  // @ts-ignore
  return <>
    {((!customer?.loggedIn || !user?.birthDate || user?.birthDate === '') && !user?.id) && <>
      <div className={cx(styles.r24FullWidth, styles.noBorderAround, styles.r24BottomMargin10, "text-center")}>
        <div className={styles.returningcustomer}>
          <h2><Translate content={'vehicleSearch1.existingCustomer'}/></h2>
          <p><Translate content={'vehicleSearch1.logInUsingYourPhone'}/></p>
        </div>
        <button className={cx("btn", styles.orangeButton)} onClick={() => {
          setShowLogin(true);
          sendGaEvent('customer', 'openLogin', '', 0);
        }}>
          {translateService.translate('vehicleSearch1.login').toUpperCase()}
        </button>
      </div>
    </>
    }
    <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>

    <CustomerCheckboxInput label={translateService.translate("vehicleSearch1.company")}
                           fieldName={"companyCheckField"}
                           formSubmitted={formSubmitted}
                           errorString={isCompanyErrorString} setValue={setIsCompany}
                           checked={isCompany}/>

    {isCompany &&
        <>
          <div className={cx(styles.r24FullWidthFlexNormal, styles.r24TopBottomMargin10)}>
            <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.companyName")}
                               errorString={companyNameErrorString}
                               value={companyName}
                               fieldName={companyNameFieldRef}
                               setValue={setCompanyName}
                               formSubmitted={formSubmitted}
                               className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
            />
            <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.companyID")}
                               errorString={companyIdErrorString}
                               value={companyId}
                               fieldName={companyIdFieldRef}
                               setValue={setCompanyId}
                               formSubmitted={formSubmitted}
                               className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
            />
          </div>
          <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.companyReference")}
                             errorString={companyRefErrorString}
                             value={companyRef}
                             formSubmitted={formSubmitted}
                             fieldName={"companyReferenceField"}
                             setValue={setCompanyRef}
                             className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
          />
        </>
    }

    <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>
    <div className={cx(styles.r24FullWidthFlexNormal, styles.r24BottomMargin10)}>

      <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.name")}
                         errorString={givenNameErrorString}
                         value={givenName}
                         fieldName={givenNameFieldRef}
                         setValue={setGivenName}
                         formSubmitted={formSubmitted}
                         className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
      />

      <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.surname")}
                         errorString={familyNameErrorString}
                         value={familyName}
                         formSubmitted={formSubmitted}
                         fieldName={familyNameFieldRef}
                         setValue={setFamilyName}
                         className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
      />
    </div>
    {(!customer?.loggedIn && language === 'en') ?
        <CustomerCheckboxInput label='I do not live in Finland' errorString={isCountryForeignErrorString}
                               fieldName={"foreignCountryCheckField"}
                               formSubmitted={formSubmitted}
                               setValue={setIsCountryForeign}
                               checked={isCountryForeign}/> : null
    }

    <div className={cx(styles.r24FullWidthFlexNormal, styles.r24TopBottomMargin10)}>
      {!customer?.loggedIn || !user?.birthDate || user?.birthDate !== '' ? // not logged in OR no birthdate
          isCountryForeign ? // get birthdate
              <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.birthDate")}
                                 errorString={dateOfBirthErrorString}
                                 value={isCustomerLoggedIn ? "xxxxxxxx" : dateOfBirth}
                                 setValue={setDateOfBirth}
                                 formSubmitted={formSubmitted}
                                 fieldName={dateOfBirthFieldRef}
                                 disableInput={isCustomerLoggedIn}
                                 className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}

              />
              : // Finish resident: social security no.
              <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.socialSecurity")}
                                 errorString={socialSecurityNumErrorString}
                                 value={isCustomerLoggedIn ? "xxxxxxxx-xxx" : socialSecurityNum}
                                 setValue={setSocialSecurityNum}
                                 fieldName={SSNFieldRef}
                                 formSubmitted={formSubmitted}
                                 disableInput={isCustomerLoggedIn}
                                 className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}

              />
          : // if birthdate is already set from profile
          <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.loginHetuText")}
                             errorString={socialSecurityNumErrorString}
                             value={isCustomerLoggedIn ? (user?.country ? "xxxxxxxx" : "xxxxxxxx-xxx") : socialSecurityNum}
                             setValue={setSocialSecurityNum}
                             formSubmitted={formSubmitted}
                             fieldName={SSNFieldRef}
                             disableInput={isCustomerLoggedIn}
                             className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
          />
      }
      <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.address")}
                         errorString={addressErrorString}
                         value={address}
                         fieldName={addressFieldRef}
                         formSubmitted={formSubmitted}
                         setValue={setAddress}
                         className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
      />
    </div>
    <div id="city{vehicle.id}" className={cx(styles.r24FullWidthFlexNormal, styles.r24BottomMargin10)}>
      <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.city")}
                         errorString={cityErrorString}
                         value={city}
                         formSubmitted={formSubmitted}
                         fieldName={cityFieldRef}
                         setValue={setCity}
                         className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
      />
      <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.postal")}
                         errorString={zipCodeErrorString}
                         value={zipCode}
                         formSubmitted={formSubmitted}
                         fieldName={zipCodeFieldRef}
                         setValue={setZipCode}
                         className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
      />
    </div>

    {(isCountryForeign || (user?.country === null && user?.noPersonalIdCode)) && // added case to look for loggedIn but country info missing
        <div className={'mr-md-1 mr-lg-1 mr-xl-1 mr-0'}>
          <CountrySelect errorString={foreignCountryErrorString} placeholder={translateService.translate("vehicleSearch1.country")}
                         userLanguage={user?.language || language} value={foreignCountry} setValue={setForeignCountry}
                         fieldName={countryFieldRef}/>
        </div>
    }

    <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>
    <div className={cx(styles.r24FullWidth)}>
      {(!customer?.loggedIn || !user?.birthDate || user?.birthDate !== '') &&
          <>
            <div className={styles.phonenumber}><Translate content={'vehicleSearch1.phonenumberdescription1'}/></div>
            <div className={'w-100 flex-row d-flex m-0 p-0'}>
              <div className={'px-0 m-0'}>
                <CustomerCheckboxInput label={translateService.translate("vehicleSearch1.secret")}
                                       errorString={''}
                                       formSubmitted={formSubmitted}
                                       fieldName={"secretNumField"}
                                       setValue={setPrivateNum}
                                       className={cx(styles.r24FullWidth, styles.r24PhoneNumber)}
                                       checked={privateNum}/>
              </div>
              <div className={'px-4 m-0'}>
                  <CustomerCheckboxInput label={translateService.translate("vehicleSearch1.prepaid")}
                                         errorString={''}
                                         formSubmitted={formSubmitted}
                                         fieldName={"prepaidNumField"}
                                         setValue={setPrepaidNum}
                                         className={cx(styles.r24FullWidth, styles.r24PhoneNumber)}
                                         checked={prepaidNum}/>
              </div>
            </div>
          </>
      }
    </div>

    <div className={cx(styles.r24FullWidthFlexNormal, styles.r24BottomMargin10)}>
      <div className={styles.phonenumber}><Translate content={'vehicleSearch1.phonenumberdescription2'}/></div>
    </div>
    <div >
    <div className={cx(styles.r24FullWidthFlexNormal, styles.r24BottomMargin10)}>
      <CustomerTextInput placeholder={translateService.translate("loginScreen.phoneNumber") + " *"}
                         errorString={phoneNumberErrorString}
                         value={phoneNumber}
                         fieldName={phoneNum1FieldRef}
                         setValue={setPhoneNumber}
                         formSubmitted={formSubmitted}
                         className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
                         disableInput={user?.smsLogin && (isCustomerLoggedIn || !!user?.id)}
      />

      {(!customer?.loggedIn && !user?.id) || !user?.smsLogin  ?
          <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.phonerepeat") + " *"}
                             errorString={reEnterPhoneErrorString}
                             value={reEnterPhone}
                             formSubmitted={formSubmitted}
                             fieldName={phoneNum2FieldRef}
                             setValue={setReEnterPhone}
                             className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
          /> : null
      }

    </div>
    <div className={`${cx(styles.r24FullWidthFlexNormal, styles.r24BottomMargin10)} `}>
      <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.email") + " *"}
                         errorString={emailErrorString}
                         value={email}
                         formSubmitted={formSubmitted}
                         fieldName={email1FieldRef}
                         setValue={setEmail}
                         className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
      />

          <CustomerTextInput placeholder={translateService.translate("vehicleSearch1.emailrepeat") + " *"}
                             errorString={reEnterEmailErrorString}
                             value={reEnterEmail}
                             formSubmitted={formSubmitted}
                             fieldName={email2FieldRef}
                             setValue={setReEnterEmail}
                             className={cx(styles.r24ChildFlex1, styles.grayBorderAround, styles.r24CustomerInfoRight, styles.vehicleSearch)}
          />

    </div>
    </div>
    <div className={cx(styles.r24FullWidth, styles.lightGrayline, styles.r24TopBottomMargin5)}></div>

    { saveInfoBtnClicked ?
        <div className={cx(styles.r24FullWidth, styles.r24FullWidthFlexPageSelection)} style={{alignItems: "center"}}>
          {/* This section is only for the submit error message to match + align it perfectly above the Save Information text*/}
          <div className={cx(styles.r24ChildFlex1, styles.r24RightMargin5)}></div>
          <div className={cx(styles.r24ChildFlex4, styles.r24LeftMargin5)}>
            <div className={cx(styles.r24FullWidthFlexPageSubmitError)}>{submitValidationErrorString}</div>
          </div>
        </div>
        : null
    }
    <div className={cx(styles.r24FullWidth, styles.r24Padding10, styles.r24FullWidthFlexPageSelection)} style={{alignItems: "center"}}>
      <div className={cx(styles.r24ChildFlex1, styles.r24RightMargin5)} scroll-to-item="true"
           scroll-to="#rentalStepsTop">
        <button type="button" className={cx("btn", styles.btn, styles.grayButton)} onClick={() => {back(); sendGaEvent('reservation', 'backToBeginReservation', '', 0); }}>
          <ArrowBackIcon className={styles.arrowIcon}/>
        </button>
      </div>
      <div className={cx(styles.r24ChildFlex4, styles.r24LeftMargin5)} scroll-to-item="true"
           scroll-to="#rentalStepsTop">
        <button type="submit" className={cx("btn", styles.btn, styles.orangeButton)} style={{verticalAlign: "top"}}
                onClick={(e: any) => {setSaveInfoBtnClicked(true); handleSubmit(e)}} autoFocus>
          {translateService.translate('vehicleSearch1.continueToPayment').toUpperCase()}
        </button>
      </div>
    </div>
  </>
}
